import { render, staticRenderFns } from "./LoversAndHatersFilter.vue?vue&type=template&id=197f3bc1&scoped=true&"
import script from "./LoversAndHatersFilter.vue?vue&type=script&lang=js&"
export * from "./LoversAndHatersFilter.vue?vue&type=script&lang=js&"
import style0 from "./LoversAndHatersFilter.vue?vue&type=style&index=0&id=197f3bc1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f3bc1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {VChip})
